/* English. Keys are the Slovene source strings. */
export const en = {
  // prijava
  'Dobrodošel v Učilnici': 'Welcome to Učilnica',
  'Tvoj program šolanja, knjižica letenja in pot do izpita — na enem mestu.':
    'Your training syllabus, flight log and path to the licence exam, in one place.',
  'Prijava z Google računom': 'Sign in with Google',
  'Odpiram Google …': 'Opening Google …',
  'Varstvo osebnih podatkov': 'Privacy policy',
  'Program šolanja': 'Training syllabus',
  'Namesti aplikacijo': 'Install the app',
  Namesti: 'Install',
  'Si šola jadralnega padalstva?': 'Are you a paragliding school?',
  'Učilnica za vašo šolo': 'Učilnica for your school',

  // vpis
  'Dobrodošel v Učilnici šole {sola}': 'Welcome to the {sola} Učilnica',
  'Izpolni podatke — to je potrebno samo enkrat. Številko tečajnika dobiš takoj po shranjevanju.':
    'Fill in your details — only once. You get your student number right after saving.',
  Šola: 'School',
  'Izberi šolo, pri kateri se šolaš.': 'Pick the school you train with.',
  'Imaš kodo šole?': 'Got a school code?',
  'Koda šole': 'School code',
  'Potrdi kodo': 'Apply code',
  'Šola s to kodo ne obstaja.': 'No school has this code.',
  'Potrdi in začni šolanje': 'Confirm and start training',
  'Shranjujem …': 'Saving …',
  'Nazaj na prijavo': 'Back to sign-in',
  'Kje si izvedel za nas?': 'How did you hear about us?',
  'Neobvezno. Pomaga nam vedeti, kje nas ljudje najdejo.': 'Optional. Helps us learn where people find us.',
  'Raje ne povem': 'Prefer not to say',
  'S potrditvijo izjavljam, da se tečaja udeležujem na lastno odgovornost.':
    'I confirm that I take part in the course at my own risk.',
  'Podatke uporabimo za vodenje šolanja in prijavo na izpit.':
    'We use your details to run your training and to register you for the exam.',
  'Kako ravnamo s tvojimi podatki': 'How we handle your data',

  // ustvari šolo
  'Kdo si': 'Who are you',
  'Sem tečajnik': 'I am a student',
  'Sem inštruktor — ustvari šolo': 'I am an instructor — create a school',
  'Ustvari svojo šolo': 'Create your school',
  'Postaneš lastnik šole. Preizkus traja 30 dni, do 10 tečajnikov, vse funkcije. Program lahko kadarkoli dopolniš.':
    'You become the school owner. The trial lasts 30 days, up to 10 students, every feature. You can extend the syllabus any time.',
  'Ime šole': 'School name',
  'Tvoje ime': 'Your name',
  Država: 'Country',
  'Jezik vmesnika': 'Interface language',
  Telefon: 'Phone',
  'Spletna stran': 'Website',
  'Prebranih {n} vaj. Prazno = Perutov program kot izhodišče.': '{n} exercises parsed. Empty = start from the Perut syllabus.',
  'Vrstica = vaja, vrstica z vezajem = pod-vaja, vrstica z # = sklop. Prazno = Perutov program kot izhodišče.':
    'One line per exercise, a dash for a sub-exercise, # for a section. Empty = start from the Perut syllabus.',
  'Lastnik šole si s tem Google računom:': 'You own the school with this Google account:',
  'Ustvarjam …': 'Creating …',
  'Ustvari šolo': 'Create school',

  // interaktivne vsebine (naslovi na seznamu; vsebine so slovenske)
  'Priprava padala in pet kontrolnih točk': 'Preparation and the five-point check',
  'Krilo, vrvice, sedež, karabina. Nato tik pred vzletom pet točk na pamet.': 'Wing, lines, harness, carabiners. Then, right before launch, the five points by heart.',
  '3D kontrola · 3 stopnje': '3D check · 3 levels',
  'Začetni tečaj, vaja 1': 'Basic course, exercise 1',
  'Dvig krila in vzlet': 'Inflation and launch',
  'Polnjenje, dvig in stabilizacija krila, pospeševanje in vzlet.': 'Inflating, raising and stabilising the wing, the run and take-off.',
  '3D simulacija · 4 stopnje': '3D simulation · 4 levels',
  'Začetni tečaj, vaji 2 in 3': 'Basic course, exercises 2 and 3',
  'Levo in desno': 'Left and right',
  'Ko krilo uhaja vstran: stopiš pod krilo in hkrati kontriraš s komando.': 'When the wing drifts sideways: step under it and counter with the brake at the same time.',
  '3D simulacija': '3D simulation',
  'Začetni tečaj, vaja 2': 'Basic course, exercise 2',
  'Prekinitev vzleta': 'Aborting the launch',
  'Ko krilo ni stabilno: zavreš eno stran in tečeš bočno.': 'When the wing is not stable: brake one side and run across the slope.',
  'Vzvratni dvig krila': 'Reverse launch',
  'V močnejšem vetru: obrnjen proti krilu ga dvigneš, stabiliziraš, se obrneš in vzletiš.': 'In stronger wind: facing the wing, bring it up, stabilise, turn and launch.',
  '3D simulacija · 3 stopnje': '3D simulation · 3 levels',
  'Začetni tečaj, vaja 2 · nadaljevalni tečaj, vaja 1': 'Basic course, exercise 2 · advanced course, exercise 1',
  Zavoji: 'Turns',
  'Komanda in nagib telesa: počasi vlečeš, nagneš se v smer zavoja.': 'Brake and weight shift: pull slowly, lean into the turn.',
  '3D simulacija · 2 stopnji': '3D simulation · 2 levels',
  'Začetni tečaj, vaja 4': 'Basic course, exercise 4',
  Pristanek: 'Landing',
  'Osmice na razdeljenem polju, šolski krog in izravnava proti vetru.': 'Figure-eights over a split field, the landing circuit and the flare into wind.',
  'Začetni in nadaljevalni tečaj': 'Basic and advanced course',
  Kroženje: 'Thermalling circles',
  'Zaprt zavoj za 360°, ki ga držiš enakomerno: levo, desno, izmenično in let po osi.': 'A steady 360° turn: left, right, alternating and back on the axis.',
  'Nadaljevalni tečaj, vaja 3': 'Advanced course, exercise 3',
  'Nadzorovano nihanje in aktivno pilotiranje': 'Pitch and roll control, active flying',
  'Krilo in pilot sta nihalo: spredaj zavreš, zadaj popustiš. Vstran dušiš nasprotno od gibanja.': 'Wing and pilot are a pendulum: brake when it surges, release when it hangs back. Dampen roll against the motion.',
  'Nadaljevalni tečaj, vaja 4': 'Advanced course, exercise 4',
  'Pospešen let': 'Speed bar',
  'Nožni pospeševalnik: proti vetru, korekcija smeri z nagibom, v turbulenci ga spustiš.': 'The speed bar: into wind, heading with weight shift, released in turbulence.',
  'Nadaljevalni tečaj, vaja 5': 'Advanced course, exercise 5',
  Ušesa: 'Big ears',
  'Hitro spuščanje: zložena konca krila, pospeševalnik, zavoj z nagibom.': 'Fast descent: folded wing tips, speed bar, steering with weight shift.',
  'Nadaljevalni tečaj, vaja 6': 'Advanced course, exercise 6',
  'Vodenje z zadnjima trakovoma': 'Rear-riser steering',
  'Če se pretrga krmilna vrvica: krilo vodiš z zadnjima trakovoma in nagibom telesa, pristaneš proti vetru.': 'If a brake line breaks: steer with the rear risers and weight shift, land into wind.',
  'Nadaljevalni tečaj, vaja 7': 'Advanced course, exercise 7',
  'Enostransko zapiranje in reševanje': 'Asymmetric collapse and recovery',
  'Teža na odprto stran, odprto stran rahlo zavreš, zaprto pumpaš.': 'Weight on the open side, a little brake on the open side, pump the closed side.',
  'Nadaljevalni tečaj, vaja 8 · začetni tečaj, vaja 3 (simulacija)': 'Advanced course, exercise 8 · basic course, exercise 3 (simulation)',
  'Negativni zavoj': 'Spin',
  'Zakaj komande nikoli ne vlečeš sunkovito in pregloboko.': 'Why you never pull the brake abruptly or too deep.',
  '3D prikaz · 2 stopnji': '3D demonstration · 2 levels',
  Varnost: 'Safety',
  'Full stall': 'Full stall',
  'Zakaj v zraku nikoli ne zaviraš do konca.': 'Why you never brake all the way in the air.',
  '3D prikaz': '3D demonstration',

  // navigacija
  Program: 'Syllabus',
  Knjižica: 'Logbook',
  Učenje: 'Learn',
  Izpit: 'Exam',
  Leti: 'Flights',
  Dnevi: 'Days',
  Pogoji: 'Requirements',
  Test: 'Test',
  Dokumenti: 'Documents',
  Tečajniki: 'Students',
  Teren: 'Field day',
  Vsebine: 'Content',
  Razlage: 'Explanations',
  Kontakti: 'Leads',
  Platforma: 'Platform',
  Nastavitve: 'Settings',
  Inštruktorji: 'Instructors',
  Licenca: 'Licence',
  Tečajnik: 'Student',
  Inštruktor: 'Instructor',
  'Lastnik šole': 'School owner',
  Odjava: 'Sign out',
  Nazaj: 'Back',
  'Moji podatki': 'My details',
  'Preklopi na temno': 'Switch to dark',
  'Preklopi na svetlo': 'Switch to light',
  'Skoči na vsebino': 'Skip to content',
  Razdelki: 'Sections',
  Pogledi: 'Views',
  'Brez povezave': 'Offline',
  'Nalagam …': 'Loading …',
  Nalagam: 'Loading',
  'Nekaj je šlo narobe': 'Something went wrong',
  'Poskusi znova': 'Try again',
  'Osvežujem …': 'Refreshing …',
  'Spusti za osvežitev': 'Release to refresh',
  Potegni: 'Pull',

  // skupni gumbi in sporočila
  Shrani: 'Save',
  Prekliči: 'Cancel',
  Potrdi: 'Confirm',
  Zapri: 'Close',
  Izbriši: 'Delete',
  Odstrani: 'Remove',
  Oglej: 'View',
  Naloži: 'Upload',
  Zamenjaj: 'Replace',
  Razveljavi: 'Undo',
  Dodaj: 'Add',
  Vsi: 'All',
  Išči: 'Search',
  'Počisti iskanje': 'Clear search',
  Počisti: 'Clear',
  Kopiraj: 'Copy',
  'Ni zadetkov': 'No matches',
  Datum: 'Date',
  Opomba: 'Note',
  Vzletišče: 'Site',
  Neobvezno: 'Optional',
  Ročno: 'Manual',
  od: 'of',
  'Shranjevanje ni uspelo.': 'Saving failed.',
  'Brisanje ni uspelo.': 'Deleting failed.',
  'Nalaganje ni uspelo.': 'Upload failed.',
  'Ni uspelo.': 'Failed.',
  'Shranjeno.': 'Saved.',
  Shranjeno: 'Saved',
  'Ni shranjeno': 'Not saved',
  'PDF ni bilo mogoče ustvariti.': 'The PDF could not be created.',
  Obvestila: 'Notifications',
  'Zapri obvestilo': 'Close notification',
  'Za potrditev vpiši': 'To confirm, type',
  '{a} od {b}': '{a} of {b}',
  '{a} od {b} — {p} odstotkov': '{a} of {b} — {p} percent',
  Potrjeno: 'Confirmed',
  Zavrnjeno: 'Rejected',
  Čaka: 'Waiting',
  potrjeno: 'confirmed',
  potrjenih: 'confirmed',
  zavrnjenih: 'rejected',
  čaka: 'waiting',
  'čaka potrditev': 'awaiting confirmation',
  'čaka inštruktorja': 'waiting for the instructor',
  letov: 'flights',
  vzletišč: 'sites',
  vaj: 'exercises',
  'pod-vaj': 'sub-exercises',
  šolanja: 'of training',
  'št.': 'no.',

  // pogoji za izpit (progress.js)
  '{sklop} potrjen': '{sklop} confirmed',
  'Vsaj {n} potrjenih letov': 'At least {n} confirmed flights',
  'Leti na vsaj {n} različnih vzletiščih': 'Flights from at least {n} different sites',
  'Zaključni test opravljen': 'Final test passed',
  'Teoretični izpit opravljen': 'Theory exam passed',
  'Starost vsaj {n} let': 'Age at least {n}',
  '{n} let': '{n} years',
  'manjka datum rojstva': 'date of birth missing',
  'Veljaven zdravniški za B kategorijo': 'Valid category B medical',
  'ni naloženo': 'not uploaded',
  'manjka datum': 'date missing',
  'potekel {d}': 'expired {d}',
  'velja do {d}': 'valid until {d}',

  // polja profila (profileFields.js)
  'Ime in priimek': 'First and last name',
  'npr. Janez Novak': 'e.g. John Smith',
  'Datum rojstva': 'Date of birth',
  'Kraj rojstva': 'Place of birth',
  'npr. Ljubljana': 'e.g. Ljubljana',
  'Naslov stalnega prebivališča': 'Home address',
  'npr. Dunajska cesta 5': 'e.g. 5 High Street',
  Pošta: 'Postcode and town',
  'npr. 1000 Ljubljana': 'e.g. 1000 Ljubljana',
  'Telefonska številka': 'Phone number',
  'npr. 040 123 456': 'e.g. 040 123 456',
  'Datum pričetka tečaja': 'Course start date',
  'Višina (cm)': 'Height (cm)',
  'npr. 178': 'e.g. 178',
  'Teža (kg)': 'Weight (kg)',
  'npr. 75': 'e.g. 75',
  'Zdravstvene omejitve ali posebnosti': 'Medical limitations or conditions',
  'Vpiši, če obstajajo. Sicer pusti prazno.': 'Enter if any. Otherwise leave empty.',
  'Kontaktna oseba v nujnih primerih': 'Emergency contact',
  'Ime in telefonska številka': 'Name and phone number',
  'Koga naj pokličemo, če se ti kaj zgodi.': 'Who we should call if something happens to you.',
  'Dodatna vprašanja': 'Additional questions',
  'Morebitna vprašanja za inštruktorja': 'Any questions for the instructor',
  'To polje je obvezno.': 'This field is required.',
  'Vpiši ime in priimek.': 'Enter your first and last name.',
  'Brez potrjene izjave šolanja ne moremo začeti.': 'We cannot start training without the confirmed declaration.',

  // dokumenti (exercises.js DOCS)
  'Osebna izkaznica – spredaj': 'ID card – front',
  'Osebna izkaznica – zadaj': 'ID card – back',
  'Zdravniški pregled': 'Medical examination',

  // viri (viri.js)
  'Bil sem na tandem poletu pri vas': 'I had a tandem flight with you',
  'Priporočil mi je znanec': 'A friend recommended you',
  'Našel sem vas na Googlu': 'I found you on Google',
  'Facebook ali Instagram': 'Facebook or Instagram',
  'Spletna stran perut.net': 'The perut.net website',
  'Dogodek, sejem ali vzletišče': 'An event, fair or flying site',
  Drugo: 'Other',

  // tečajnik — glavni zaslon
  'Teoretična vprašanja': 'Theory questions',
  'Vadi za teoretični izpit': 'Practise for the theory exam',
  Učbenik: 'Textbook',
  'Uradni učbenik v PDF': 'Official textbook as PDF',
  'Zdravniški pregled čaka na potrditev inštruktorja': 'Medical examination awaiting instructor confirmation',
  'Zdravniški pregled je potekel': 'Medical examination has expired',
  'Opravi zdravniški pregled za B kategorijo': 'Get a category B medical examination',
  'Opravi ga na začetku tečaja, ne pred izpitom. Brez njega ne smeš leteti.':
    'Do it at the start of the course, not before the exam. Without it you may not fly.',
  'Zaključni test še ni opravljen': 'Final test not passed yet',
  'Rešiti ga moraš pred višinskimi leti.': 'You must pass it before high flights.',
  'Povzetek napredka': 'Progress summary',
  'Živjo,': 'Hi,',
  'Potrjenih vaj: {a} od {b}': 'Confirmed exercises: {a} of {b}',
  '{n} odkljukanih vaj še ni potrjenih.': '{n} ticked exercises are not confirmed yet.',
  'Zapri predogled': 'Close preview',
  'Predogled — samo za gledanje': 'Preview — read only',
  'tečaj od': 'course since',
  'Nazaj v admin': 'Back to admin',

  // pot do izpita (ExamCard)
  'Shrani let': 'Save flight',
  'Opomniki': 'Reminders',
  'Pripravljen na izpit': 'Ready for the exam',
  'Pot do izpita': 'Path to the exam',
  'Vsi pogoji so izpolnjeni.': 'All requirements met.',
  'Izpolnjenih {a} od {b} pogojev.': '{a} of {b} requirements met.',
  'Pogoji za izpit: {a} od {b}': 'Exam requirements: {a} of {b}',
  'Zdravniško poteče čez {n} dni': 'Medical expires in {n} days',
  'Označi opravljeno': 'Mark as passed',
  'Datum zdravniškega pregleda': 'Date of medical examination',
  'Datum pregleda, ne datum nalaganja dokumenta': 'Date of the examination, not the upload date',
  'Se preverja': 'Checking',
  Izpolnjeno: 'Met',
  'Še ni izpolnjeno': 'Not met yet',

  // program vaj
  '{sklop}: {a} od {b} potrjenih': '{sklop}: {a} of {b} confirmed',
  'Razlaga vaje': 'Exercise explanation',
  'Razlaga pod-vaje': 'Sub-exercise explanation',
  Razlaga: 'Explanation',
  'Razlaga: {sub}': 'Explanation: {sub}',
  'Tvoja opomba k vaji': 'Your note on the exercise',
  'Pogoji, kako je šlo, kaj želiš ponoviti …': 'Conditions, how it went, what to repeat …',
  'Opomba shranjena': 'Note saved',
  'Potrjene vaje ni mogoče spremeniti': 'A confirmed exercise cannot be changed',
  'Datum za: {sub}': 'Date for: {sub}',
  'Datum potrjene vaje spremeni inštruktor': 'The instructor changes the date of a confirmed exercise',
  'Datum opravljanja': 'Date completed',

  // knjižica letenja
  'Let je vpisan. Viden bo, ko ga inštruktor potrdi.': 'Flight logged. It shows once the instructor confirms it.',
  'Leta ni bilo mogoče vpisati.': 'The flight could not be logged.',
  'Izbrišem ta let?': 'Delete this flight?',
  'Let z dne {d}': 'Flight on {d}',
  'Let je izbrisan.': 'Flight deleted.',
  'Potrjeni leti': 'Confirmed flights',
  'od {n}': 'of {n}',
  'Čaka potrditev': 'Awaiting confirmation',
  Vzletišča: 'Sites',
  'Potrjenih letov: {a} od {b}': 'Confirmed flights: {a} of {b}',
  'Vpiši let': 'Log a flight',
  'npr. Tolmin, Lijak': 'e.g. Tolmin, Lijak',
  'Pogoji, padalo, kako je šlo': 'Conditions, wing, how it went',
  'Vpisujem …': 'Logging …',
  '+ Vpiši let': '+ Log flight',
  'Pripravljam PDF …': 'Preparing PDF …',
  'Izvozi knjižico v PDF': 'Export logbook to PDF',
  'Še ni vpisanih letov': 'No flights logged yet',
  'Vpiši prvi let zgoraj. Inštruktor ga potrdi, ko ga pregleda.':
    'Log your first flight above. The instructor confirms it after review.',
  'Izbriši let št. {n}': 'Delete flight no. {n}',

  // dnevnik prisotnosti
  'Dan je dodan v dnevnik.': 'Day added to the diary.',
  'Dneva ni bilo mogoče dodati.': 'The day could not be added.',
  'Izbrišem ta dan?': 'Delete this day?',
  '{d} bo odstranjen iz dnevnika prisotnosti.': '{d} will be removed from the attendance diary.',
  'Dan je izbrisan.': 'Day deleted.',
  'Dnevnik prisotnosti': 'Attendance diary',
  'Dnevi z vajami in leti se vpišejo samodejno.': 'Days with exercises and flights are added automatically.',
  'Dodaj dan': 'Add a day',
  'npr. teorija, vaja na tleh': 'e.g. theory, ground handling',
  'Dodajam …': 'Adding …',
  '+ Dodaj dan': '+ Add day',
  'Še ni zabeleženih dni': 'No days recorded yet',
  'Ko odkljukaš vajo ali vpišeš let, se dan pojavi tukaj sam.':
    'Tick an exercise or log a flight and the day appears here by itself.',
  'Izbriši dan {d}': 'Delete day {d}',
  Skupaj: 'Total',

  // dokumenti
  Dokumentacija: 'Documents',
  'Naloži fotografije. Vidita jih samo ti in inštruktor.': 'Upload photos. Only you and the instructor can see them.',
  'Zdravniško spričevalo je eden od pogojev za pristop k izpitu.': 'The medical certificate is one of the exam requirements.',
  '{doc} je naložen.': '{doc} uploaded.',
  'Izbrišem {doc}?': 'Delete {doc}?',
  'Fotografija bo trajno odstranjena. Naložiš jo lahko znova.': 'The photo will be removed permanently. You can upload it again.',
  'Dokument je izbrisan.': 'Document deleted.',
  Naloženo: 'Uploaded',
  'Ni naloženo': 'Not uploaded',
  'Izbriši {doc}': 'Delete {doc}',
  'Naloži: {doc}': 'Upload: {doc}',
  'Povečaj: {doc}': 'Enlarge: {doc}',
  'Odpri v novem zavihku': 'Open in a new tab',
  'Dokument se odpre v novem zavihku.': 'The document opens in a new tab.',

  // izpit — prijava
  'Kaj potrebuješ za prijavo': 'What you need to apply',
  'Izpolnjena knjižica letenja': 'Completed flight log',
  'Vsaj {a} letov z nadaljevalnega tečaja, na vsaj {b} različnih vzletiščih, z višinsko razliko vsaj {c} m.':
    'At least {a} flights from the advanced course, from at least {b} different sites, with an altitude difference of at least {c} m.',
  'Višinske razlike aplikacija ne beleži — to preveri inštruktor ob pregledu knjižice.':
    'The app does not record altitude difference — the instructor checks it when reviewing the flight log.',
  'Zdravniški pregled za B kategorijo': 'Category B medical examination',
  'ni vpisan': 'not entered',
  'Opravi ga na začetku tečaja, ne pred izpitom.': 'Do it at the start of the course, not before the exam.',
  'Ne sme biti starejši od {n} mesecev.': 'It must not be older than {n} months.',
  'Noben drug zdravniški pregled ni enakovreden': 'No other medical examination is equivalent',
  'potrdilu za B kategorijo (avto).': 'to the category B (driving) certificate.',
  'Fotografijo naloži med': 'Upload the photo under',
  Dokumente: 'Documents',
  ', datum pregleda vpiše inštruktor.': ', the instructor enters the examination date.',
  Prijavnica: 'Application form',
  'Uradni obrazec agencije. Izpolni svoje podatke in obkljukaj': 'The agency’s official form. Fill in your details and tick',
  'Jadralno padalo (PG)': 'Paraglider (PG)',
  'ter del izpita, na katerega se prijavljaš. Spodnji del izpolni in podpiše inštruktor — prijavnico mu prinesi, preden jo pošlješ.':
    'and the part of the exam you are applying for. The instructor fills in and signs the bottom part — bring the form to them before you send it.',
  'Prenesi prijavnico': 'Download the form',
  'Kam pošlješ': 'Where to send it',
  'Potrjeno prijavnico in': 'Send the signed application form and',
  'kopijo zdravniškega pregleda': 'a copy of the medical certificate',
  pošlji: 'by',
  priporočeno: 'registered post',
  'na:': 'to:',
  'Prijavi se pravočasno — roki so vnaprej razpisani, zdravniški pregled pa se naroča vnaprej.':
    'Apply in good time — exam dates are published in advance and the medical has to be booked ahead.',
  'Izpitni roki (PDF)': 'Exam dates (PDF)',
  Vprašanja: 'Questions',
  'Celotna navodila šole': 'Full instructions from the school',
  'Zdravniški pregled je urejen': 'Medical examination in order',
  'Velja do': 'Valid until',
  'Manjka datum zdravniškega pregleda': 'Medical examination date missing',
  'Zdravniški pregled poteče čez {n} dni': 'Medical examination expires in {n} days',
  'Pregled za': 'The',
  'B kategorijo (avto)': 'category B (driving) medical',
  'sodi na': 'belongs at the',
  'začetek tečaja': 'start of the course',
  ', ne pred izpit. Brez njega ne smeš leteti, prijave na izpit pa ni mogoče oddati. Noben drug zdravniški pregled ni enakovreden.':
    ', not before the exam. Without it you may not fly and the exam application cannot be submitted. No other medical examination is equivalent.',
  'Zadnji pregled je potekel {d}.': 'The last examination expired on {d}.',
  'Naroči se čim prej — termina se pogosto čaka. Ko pregled opraviš, fotografijo naloži med Dokumente.':
    'Book it as soon as possible — there is often a wait for appointments. Once done, upload the photo under Documents.',

  // zaključni test — tečajnik
  'Vprašanj ni bilo mogoče naložiti.': 'The questions could not be loaded.',
  'Odgovori še na {n} vprašanj.': 'Answer {n} more questions.',
  'Vpiši svoje ime kot podpis.': 'Type your name as a signature.',
  'Oddam test?': 'Submit the test?',
  'Po oddaji odgovorov ni več mogoče spremeniti.': 'Answers cannot be changed after submitting.',
  'Odgovorjenih: {a} od {b}': 'Answered: {a} of {b}',
  'Za opravljeno je potrebnih {n} %': '{n} % needed to pass',
  'Oddaj test': 'Submit test',
  'Test opravljen — {s}.': 'Test passed — {s}.',
  'Test ni opravljen: {s}. Poglej razlage in poskusi znova.': 'Test not passed: {s}. Read the explanations and try again.',
  'Oddaja ni uspela.': 'Submission failed.',
  'Pregleda ni bilo mogoče naložiti.': 'The review could not be loaded.',
  'Test opravljen': 'Test passed',
  'Test ni opravljen': 'Test not passed',
  '{s} pravilnih ({p} %). Za opravljeno je potrebnih {n} %.': '{s} correct ({p} %). {n} % needed to pass.',
  'Spodaj so vprašanja, ki si jih zgrešil, in razlaga za vsako. Preberi jih,':
    'Below are the questions you missed, with an explanation for each. Read them',
  ' da snov res sede.': ' so the material really sinks in.',
  ' nato pa test reši še enkrat.': ', then take the test again.',
  'Reši test znova': 'Retake the test',
  'Vsa vprašanja pravilna': 'All answers correct',
  'Ni česa popravljati.': 'Nothing to fix.',
  'Tvoj odgovor:': 'Your answer:',
  'brez odgovora': 'no answer',
  'Pravilno:': 'Correct:',
  'Ponazoritev: {q}': 'Illustration: {q}',
  'Zaključni test': 'Final test',
  'Preverjanje znanja iz začetnega tečaja. Rešiti ga moraš': 'Knowledge check for the beginner course. You must pass it',
  'pred višinskimi leti': 'before high flights',
  Opravljen: 'Passed',
  točk: 'points',
  'Poglej, kaj si zgrešil': 'See what you missed',
  'Test še ni opravljen.': 'Test not passed yet.',
  'Začni test': 'Start the test',
  'Zadnji poskus {d}: {s} — za opravljeno je bilo potrebnih {n} %.': 'Last attempt {d}: {s} — {n} % was needed to pass.',
  'Poglej, katera vprašanja si zgrešil, in preberi razlage. Test lahko rešiš znova, kolikorkrat je treba.':
    'See which questions you missed and read the explanations. You can retake the test as many times as needed.',
  'Poglej napake in razlage': 'See mistakes and explanations',
  'Vsi poskusi': 'All attempts',
  'Ni opravljen': 'Not passed',
  'Test je iz snovi začetnega tečaja. Vzemi si čas — odgovorov po oddaji ni več mogoče spremeniti.':
    'The test covers the beginner course. Take your time — answers cannot be changed after submitting.',
  'Nalagam vprašanja …': 'Loading questions …',
  'Za opravljeno je potrebnih {n} % pravilnih odgovorov.': '{n} % correct answers needed to pass.',
  Prekini: 'Stop',
  'Na to vprašanje še nisi odgovoril.': 'You have not answered this question yet.',
  Podpis: 'Signature',
  'Vpiši svoje ime in priimek.': 'Type your first and last name.',
  'S podpisom potrjujem, da razumem osnovna pravila letenja in da se bom izogibal manevrom, za katere nisem usposobljen.':
    'With my signature I confirm that I understand the basic rules of flying and that I will avoid manoeuvres I am not trained for.',
  'Odgovorjenih {a} od {b}': 'Answered {a} of {b}',
  'Oddajam …': 'Submitting …',

  // učenje
  'Interaktivno učenje': 'Interactive learning',
  'Na tleh': 'On the ground',
  'V zraku': 'In the air',
  'Vsaka vsebina ima najprej razlago, nato jo preizkusiš sam. Ne nadomesti terena, pripravi te nanj.':
    'Each topic starts with an explanation, then you try it yourself. It does not replace the field; it prepares you for it.',
  'opravljeno {a} od {b}': 'completed {a} of {b}',
  opravljeno: 'completed',
  preverjanje: 'quiz',
  'Vse vsebine': 'All topics',
  'Samo prikaz. Namerno tega nikoli ne narediš.': 'Demonstration only. You never do this on purpose.',
  Preizkusi: 'Try it',
  'Simulacija je poenostavljena. Pokaže pravo zaporedje in občutek, terena ne nadomesti.':
    'The simulation is simplified. It shows the right sequence and feel; it does not replace the field.',
  'Nalagam 3D prikaz …': 'Loading 3D view …',
  '3D prikaza ni bilo mogoče naložiti. Preveri povezavo in poskusi znova.':
    'The 3D view could not be loaded. Check your connection and try again.',
  'Preveri znanje': 'Check your knowledge',
  '{n} kratka vprašanja o tej vsebini.': '{n} short questions on this topic.',
  'Najboljši rezultat: {a} od {b}.': 'Best result: {a} of {b}.',
  'Pravilno. ': 'Correct. ',
  'Ni pravilno. ': 'Not correct. ',
  'Vse pravilno.': 'All correct.',
  'Pravilnih {a} od {b}.': '{a} of {b} correct.',
  ' Rezultat je shranjen za inštruktorja.': ' The result is saved for the instructor.',
  Znova: 'Again',
  'Preveri odgovore': 'Check answers',

  // profil
  'Podatki so shranjeni.': 'Details saved.',
  'Moj profil': 'My profile',
  'Osebni podatki': 'Personal details',
  'Tvoja številka tečajnika je': 'Your student number is',
  'Te ni mogoče spremeniti — dodeli jo šola.': 'It cannot be changed — the school assigns it.',
  'Kdaj si dejansko začel s tečajem.': 'When you actually started the course.',
  'Tvoji podatki': 'Your data',
  'Podatki so preneseni (.txt in .json).': 'Data downloaded (.txt and .json).',
  'Prenesi vse svoje podatke': 'Download all your data',
  'Zahtevo za izbris si vložil {d}.': 'You filed a deletion request on {d}.',
  'Inštruktor jo bo obravnaval in ti sporočil, kaj je izbrisal in kaj mora šola po zakonu obdržati.':
    'The instructor will handle it and tell you what was deleted and what the school must keep by law.',
  'Zahtevaj izbris svojih podatkov': 'Request deletion of your data',
  'Fotografije dokumentov lahko izbrišeš takoj sam, v razdelku Dokumenti. Evidence šolanja in zaključnega testa šola ne sme izbrisati — te mora hraniti po predpisih. Vse ostalo izbriše inštruktor na tvojo zahtevo.':
    'You can delete document photos yourself right away, under Documents. The school may not delete training records and the final test — it must keep them by regulation. Everything else is deleted by the instructor at your request.',
  'Neobvezno: kaj konkretno želiš izbrisati.': 'Optional: what exactly you want deleted.',
  'Zahteva je vložena. Inštruktor te bo obvestil.': 'Request filed. The instructor will let you know.',
  'Zahteve ni bilo mogoče vložiti.': 'The request could not be filed.',
  'Pošiljam …': 'Sending …',
  'Vloži zahtevo': 'File request',

  // namestitev
  'Ne prikazuj več': 'Do not show again',
  Namestitev: 'Install',
  'Dodaj na domači zaslon': 'Add to home screen',
  Razumem: 'Got it',
  'Hitrejši dostop, ikona na zaslonu, odpre se brez brskalnika.': 'Faster access, an icon on your screen, opens without the browser.',
  'Tapni gumb': 'Tap the',
  Deli: 'Share',
  '(kvadratek s puščico) na dnu zaslona.': 'button (square with an arrow) at the bottom of the screen.',
  'Pomakni se navzdol in tapni': 'Scroll down and tap',
  '„Dodaj na začetni zaslon“': '“Add to Home Screen”',
  'Potrdi z': 'Confirm with',
  '„Dodaj“': '“Add”',
  'Tapni meni': 'Tap the',
  'v zgornjem desnem kotu.': 'menu in the top right corner.',
  Izberi: 'Choose',
  '„Namesti aplikacijo“': '“Install app”',
  ali: 'or',
  '„Namesti“': '“Install”',

  // razlage
  'Zakaj to delamo': 'Why we do this',
  'Kako pravilno': 'How to do it right',
  'Pogoste napake': 'Common mistakes',
  'Odpri video': 'Open video',
  'Učbenik:': 'Textbook:',

  // inštruktor — pregled
  'Nič ne čaka potrditve.': 'Nothing is awaiting confirmation.',
  'Potrdim vse?': 'Confirm everything?',
  'Za {who}.': 'For {who}.',
  'Vaje in leti skupaj: {n}': 'Exercises and flights in total: {n}',
  'Potrdi vse': 'Confirm all',
  'Potrjeno.': 'Confirmed.',
  'Potrjevanje ni uspelo.': 'Confirming failed.',
  'Potrjujem …': 'Confirming …',
  'Dostop šole je': 'School access is',
  zaprt: 'closed',
  zamrznjen: 'frozen',
  'Tečajniki in inštruktorji lahko berejo, ne morejo pa ničesar vpisati. Uredi licenco pod Šola → Licenca.':
    'Students and instructors can read but cannot write anything. Manage the licence under School → Licence.',
  'Licenca šole': 'The school licence',
  'je potekla {d}': 'expired on {d}',
  'poteče čez {n} dni ({d})': 'expires in {n} days ({d})',
  'Podaljšanje: Šola → Licenca.': 'Renewal: School → Licence.',
  'Izberi tečajnika': 'Select a student',
  'Seznam je razvrščen po številki, najnovejši zgoraj.': 'The list is sorted by number, newest first.',
  'Tečajniki se vpišejo sami: pošlji jim povezavo': 'Students sign up themselves: send them the link',
  'ali kodo šole': 'or the school code',
  Pregled: 'Overview',
  'Aktivnih tečajnikov': 'Active students',
  'Čaka potrditve': 'Awaiting confirmation',
  'Pripravljenih na izpit': 'Ready for the exam',
  Neplačanih: 'Unpaid',
  'Brez datuma tečaja': 'No course date',
  'Zahtev za izbris': 'Deletion requests',
  'Kje nas najdejo': 'How they find us',
  'Nihče še ni odgovoril. Vprašanje je v obrazcu ob vpisu — podatki se naberejo z novimi tečajniki.':
    'Nobody has answered yet. The question is in the sign-up form — data builds up with new students.',
  'Odgovorilo {a} od {b} {w}.': '{a} of {b} {w} answered.',
  ' Deleži so računani med tistimi, ki so odgovorili.': ' Shares are calculated among those who answered.',
  'Označim zahtevo za rešeno?': 'Mark the request as resolved?',
  vložena: 'filed',
  'Najprej dejansko izbriši, kar je mogoče izbrisati.': 'First actually delete what can be deleted.',
  'Evidenc šolanja in zaključnega testa ne brišeš — te mora šola hraniti.':
    'Do not delete training records and the final test — the school must keep them.',
  'Tečajniku sporoči, kaj je izbrisano in kaj je obdržano ter zakaj.': 'Tell the student what was deleted, what was kept and why.',
  'Označi za rešeno': 'Mark as resolved',
  'Zahteva je označena za rešeno.': 'Request marked as resolved.',
  'Zahteva za izbris podatkov': 'Data deletion request',
  'Zahteve za izbris podatkov ({n})': 'Data deletion requests ({n})',
  'Po GDPR jih obravnavaj v razumnem roku. Evidence šolanja in zaključnega testa ne brišeš — te mora šola hraniti. Tečajniku sporoči, kaj je izbrisano in kaj obdržano.':
    'Under GDPR, handle them within a reasonable time. Do not delete training records and the final test — the school must keep them. Tell the student what was deleted and what was kept.',
  'Neznan tečajnik': 'Unknown student',
  Odgovori: 'Reply',

  // seznam tečajnikov
  'Filter seznama': 'List filter',
  Aktivni: 'Active',
  Arhiv: 'Archive',
  'Številka ali ime': 'Number or name',
  'Izvozi oštevilčene tečajnike v CSV za Excel': 'Export numbered students to CSV for Excel',
  'Izvoženih {n} {w}.': 'Exported {n} {w}.',
  'Samo tisti, ki čakajo potrditev': 'Only those awaiting confirmation',
  'Nič ne čaka': 'Nothing waiting',
  'Seznam je prazen': 'The list is empty',
  'Poskusi drugo številko ali ime.': 'Try another number or name.',
  'Vse je potrjeno.': 'Everything is confirmed.',
  'Ni izpolnil podatkov': 'Details not filled in',
  TEST: 'TEST',
  ARHIV: 'ARCHIVE',
  'Ni plačano': 'Not paid',
  'Ima opombo inštruktorja': 'Has an instructor note',
  '{name}: {a} od {b}': '{name}: {a} of {b}',

  // dan na terenu
  'Izberi vsaj enega tečajnika.': 'Select at least one student.',
  'Za vpis letov vpiši vzletišče.': 'Enter a site to log flights.',
  'Shranim samo prisotnost?': 'Save attendance only?',
  'Nisi izbral nobene vaje in nisi vpisal letov.': 'You selected no exercises and logged no flights.',
  'Shrani prisotnost': 'Save attendance',
  'Delno shranjeno:': 'Partially saved:',
  'Shranjeno — {a} {wa}, {b} novih potrjenih {wb}, {c} letov.': 'Saved — {a} {wa}, {b} newly confirmed {wb}, {c} flights.',
  'Dan in teren': 'Day and site',
  'npr. Golte': 'e.g. Golte',
  'Leti na tečajnika': 'Flights per student',
  'Največ 20': 'Max. 20',
  'Opomba dneva': 'Note for the day',
  'npr. JZ 10–15 km/h, termika po 13h': 'e.g. SW 10–15 km/h, thermals after 1 pm',
  'Kdo je na terenu': 'Who is on the field',
  'Odstrani {name}': 'Remove {name}',
  'Išči po številki ali imenu': 'Search by number or name',
  'Opravljene vaje': 'Exercises completed',
  'Toliko izbranih tečajnikov ima to že potrjeno — tem se ne bo spremenilo':
    'This many selected students already have it confirmed — nothing changes for them',
  'novih potrjenih': 'newly confirmed',
  'Shrani dan': 'Save day',

  // detajl tečajnika
  'Trajno izbrišem {name}?': 'Permanently delete {name}?',
  tečajnika: 'the student',
  'Izbrisani bodo vsi podatki. Tega ni mogoče razveljaviti.': 'All data will be deleted. This cannot be undone.',
  'osebni podatki': 'personal details',
  'ves napredek po vajah': 'all exercise progress',
  'knjižica letenja': 'flight log',
  'dnevnik prisotnosti': 'attendance diary',
  'komentarji inštruktorja': 'instructor comments',
  'Trajno izbriši': 'Delete permanently',
  IZBRIŠI: 'DELETE',
  'Tečajnik je trajno izbrisan.': 'Student permanently deleted.',
  'Nazaj na seznam': 'Back to the list',
  'Poglej aplikacijo, kot jo vidi tečajnik (samo za gledanje)': 'See the app as the student sees it (read only)',
  'Poglej kot tečajnik': 'View as student',
  'Čaka potrditev:': 'Awaiting confirmation:',
  'Teorija označena.': 'Theory marked.',
  'Teorija razveljavljena.': 'Theory unmarked.',
  'Datum pregleda je shranjen.': 'Examination date saved.',
  'Datum pregleda je izbrisan.': 'Examination date deleted.',
  'Podrobnosti tečajnika': 'Student details',
  Dnevnik: 'Diary',
  'Ime je shranjeno.': 'Name saved.',
  'Številka je shranjena.': 'Number saved.',
  Ime: 'Name',
  Priimek: 'Surname',
  'Uredi ime': 'Edit name',
  Plačano: 'Paid',
  Neplačano: 'Unpaid',
  'Pričetek tečaja': 'Course start',
  'Po tem datumu so razvrščene številke tečajnikov': 'Student numbers are ordered by this date',
  'Datum tečaja je shranjen.': 'Course date saved.',
  manjka: 'missing',
  'Kje nas je našel': 'How they found us',
  'Ni podatka': 'No data',
  'Številka tečajnika': 'Student number',
  'Shrani številko': 'Save number',
  'Testni račun': 'Test account',
  'Št. tečajnika': 'Student no.',
  'Spremeni številko': 'Change number',
  'Označeno kot plačano.': 'Marked as paid.',
  'Označeno kot neplačano.': 'Marked as unpaid.',
  'Označi neplačano': 'Mark unpaid',
  'Označi plačano': 'Mark paid',
  'Odznačim testni račun?': 'Unmark test account?',
  'Označim kot testni račun?': 'Mark as test account?',
  'Račun dobi naslednjo prosto številko tečajnika.': 'The account gets the next free student number.',
  'Račun izgubi številko tečajnika in ni več v izvozu.': 'The account loses its student number and is left out of exports.',
  'Ni testni': 'Not a test',
  'Aktiviram {name} nazaj?': 'Reactivate {name}?',
  'Tečajnik je spet aktiven.': 'Student is active again.',
  'Aktiviraj nazaj': 'Reactivate',
  'Izbriši trajno': 'Delete permanently',
  'Arhiviram {name}?': 'Archive {name}?',
  'Tečajnika lahko kadarkoli aktiviraš nazaj.': 'You can reactivate the student at any time.',
  'Tečajnik je arhiviran.': 'Student archived.',
  Arhiviraj: 'Archive',
  Naslov: 'Address',
  Višina: 'Height',
  Teža: 'Weight',
  'Kontakt v sili': 'Emergency contact',
  'Zdravstvene omejitve': 'Medical limitations',
  'Opombe inštruktorja — vidiš samo ti': 'Instructor notes — only you can see them',
  'npr. plačal pol tečaja, potrebuje več prakse pri zavojih …': 'e.g. paid half the course, needs more practice with turns …',
  'Opombe so shranjene.': 'Notes saved.',
  'Shrani opombe': 'Save notes',
  'Pokaži samo vaje, ki čakajo potrditev': 'Show only exercises awaiting confirmation',
  'Vse potrjeno': 'All confirmed',
  'Vaja potrjena.': 'Exercise confirmed.',
  'Potrdi vajo': 'Confirm exercise',
  'Potrdi: {sub}': 'Confirm: {sub}',
  'Zavrni: {sub}': 'Reject: {sub}',
  'Komentar inštruktorja …': 'Instructor comment …',
  'Komentar za {ex}': 'Comment for {ex}',
  'Komentar shranjen.': 'Comment saved.',
  'Knjižica letenja': 'Flight log',
  'Ni vpisanih letov': 'No flights logged',
  'Potrdi let': 'Confirm flight',
  'Zavrni let': 'Reject flight',
  'npr. teorija, opazovanje': 'e.g. theory, observing',
  'Dan je dodan.': 'Day added.',
  'Stopnje: {a} od {b}': 'Levels: {a} of {b}',
  'Preverjanje:': 'Quiz:',
  'ni rešeno': 'not taken',
  Predelano: 'Completed',
  Začeto: 'Started',
  'Ni začeto': 'Not started',

  // zaključni test — inštruktor
  Rezultati: 'Results',
  'Vprašanja in ključ': 'Questions and answer key',
  'Odgovorov ni bilo mogoče naložiti.': 'The answers could not be loaded.',
  'Izbrišem ta poskus?': 'Delete this attempt?',
  'Šola mora rezultate hraniti. Briši samo očitno napačne vnose.': 'The school must keep results. Delete only obviously wrong entries.',
  'Poskus je izbrisan.': 'Attempt deleted.',
  'Rezultati zaključnega testa': 'Final test results',
  Opravilo: 'Passed:',
  'Filter rezultatov': 'Results filter',
  Opravili: 'Passed',
  Niso: 'Not passed',
  'Še ni reševal': 'Not attempted yet',
  '1 poskus': '1 attempt',
  '{n} poskusov': '{n} attempts',
  prag: 'threshold',
  'podpis:': 'signature:',
  'Poglej odgovore': 'See answers',
  'Izbriši poskus': 'Delete attempt',
  'Odgovori — {name}': 'Answers — {name}',
  napaka: 'mistake',
  napak: 'mistakes',
  pravilno: 'correct',
  izbral: 'chosen',
  'Na to vprašanje ni odgovoril.': 'This question was not answered.',
  'Pravilni odgovor je shranjen.': 'Correct answer saved.',
  'Razlaga je shranjena.': 'Explanation saved.',
  'Slika je naložena.': 'Image uploaded.',
  'Nalaganje slike ni uspelo.': 'Image upload failed.',
  'Slika je odstranjena.': 'Image removed.',
  'Odstranjevanje ni uspelo.': 'Removing failed.',
  'Vprašanja so prenesena iz Google obrazca. Ta pravilnih odgovorov ni vseboval, zato je':
    'The questions were imported from a Google form, which did not include the correct answers, so the',
  'ključ predlagan': 'answer key is a suggestion',
  '— preveri ga in po potrebi popravi. Zeleno obrobljena možnost je trenutno pravilna.':
    '— check it and correct it where needed. The option with the green border is the current correct answer.',
  'Aktivnih vprašanj:': 'Active questions:',
  'za opravljeno je potrebnih': 'needed to pass:',
  'Razlaga in slika se tečajniku pokažeta': 'The explanation and image are shown to the student',
  'samo, če je vprašanje zgrešil': 'only if they missed the question',
  '— med reševanjem ne, ker bi slika lahko odgovor izdala. Razlage so osnutki; popravi jih po svoje.':
    '— not during the test, as the image could give the answer away. Explanations are drafts; edit them as you see fit.',
  Izključi: 'Disable',
  Vključi: 'Enable',
  'Razlaga ob napačnem odgovoru': 'Explanation for a wrong answer',
  'Zakaj je pravilen prav ta odgovor …': 'Why this answer is the correct one …',
  'Vprašanje je dodano.': 'Question added.',
  'Vprašanja ni bilo mogoče dodati.': 'The question could not be added.',
  'Dodaj vprašanje': 'Add question',
  'Novo vprašanje': 'New question',
  Vprašanje: 'Question',
  'Možni odgovori — označi pravilnega': 'Possible answers — mark the correct one',
  'Pravilen je odgovor {n}': 'Answer {n} is correct',
  'Odgovor {n}': 'Answer {n}',
  'Še en odgovor': 'Another answer',
  'Neobvezno. Pokaže se tečajniku, ki vprašanje zgreši.': 'Optional. Shown to a student who misses the question.',
  'Shrani vprašanje': 'Save question',
  'Slika (neobvezno)': 'Image (optional)',
  'Vgrajena shema. Fotografija jo povozi.': 'Built-in diagram. A photo overrides it.',
  'Zamenjaj sliko': 'Replace image',
  'Naloži sliko': 'Upload image',
  'Slika za vprašanje {n}': 'Image for question {n}',
  'Pokaže se tečajniku ob razlagi, kadar vprašanje zgreši.': 'Shown to the student with the explanation when they miss the question.',
  ' Za to vprašanje sheme ni.': ' There is no diagram for this question.',

  // razlage vaj — urejanje
  'Zakaj se izvaja ta vaja?': 'Why is this exercise done?',
  'Kako se izvede pravilno?': 'How is it done correctly?',
  'Varnostna opozorila': 'Safety warnings',
  'Razlage vaj': 'Exercise explanations',
  'Klikni na vajo ali pod-vajo za urejanje. Zelena kljukica pomeni, da razlaga obstaja.':
    'Click an exercise or sub-exercise to edit. A green tick means the explanation exists.',
  'Pod-vaja {n}': 'Sub-exercise {n}',
  'Povezava do videa (YouTube)': 'Video link (YouTube)',
  'Podpira watch?v=…, youtu.be/…, shorts/…': 'Supports watch?v=…, youtu.be/…, shorts/…',
  'Te povezave ne prepoznam kot YouTube. Video se ne bo prikazal.': 'This link is not recognised as YouTube. The video will not show.',
  'Predogled videa': 'Video preview',
  'Sklic na učbenik': 'Textbook reference',
  'npr. 4. poglavje – Vzletna tehnika, str. 78': 'e.g. chapter 4 – Launch technique, p. 78',

  // šola — nastavitve
  'Nastavitve šole so shranjene.': 'School settings saved.',
  'Logotip je naložen.': 'Logo uploaded.',
  Predstavitev: 'Profile',
  Logotip: 'Logo',
  'PNG ali SVG s prozornim ozadjem, največ 2 MB. Prikaže se v glavi aplikacije in na prijavi.':
    'PNG or SVG with a transparent background, max. 2 MB. Shown in the app header and on sign-in.',
  'Naloži logotip': 'Upload logo',
  'Kratko ime (v glavi)': 'Short name (in header)',
  'npr. Učilnica': 'e.g. Učilnica',
  'E-pošta': 'Email',
  'Vsebine (razlage, test) pišeš v svojem jeziku ne glede na to.': 'You write content (explanations, test) in your own language regardless.',
  'Hrvatski (vmesnik v slovenščini)': 'Hrvatski (interface in Slovene)',
  'Deutsch (vmesnik v angleščini)': 'Deutsch (interface in English)',
  'Italiano (vmesnik v angleščini)': 'Italiano (interface in English)',
  'Pogoji za izpit': 'Exam requirements',
  'Po teh številkah aplikacija računa „Pot do izpita“. Vpiši, kar zahteva tvoja agencija ali zveza.':
    'The app uses these numbers for the “Path to the exam”. Enter what your agency or federation requires.',
  'Najmanj potrjenih letov': 'Minimum confirmed flights',
  'Najmanj različnih vzletišč': 'Minimum different sites',
  'Najnižja starost (let)': 'Minimum age (years)',
  'Veljavnost zdravniškega (mesecev)': 'Medical validity (months)',
  'Višinska razlika leta (m)': 'Flight altitude difference (m)',
  'Samo za prikaz; aplikacija je ne preverja.': 'Display only; the app does not check it.',
  'Prag zaključnega testa (%)': 'Final test threshold (%)',
  'Agencija in prijava na izpit': 'Agency and exam application',
  'Prikaže se tečajniku v zavihku Izpit. Prazna polja se ne prikažejo.': 'Shown to the student in the Exam tab. Empty fields are hidden.',
  'Naziv agencije': 'Agency name',
  'Spletna stran agencije': 'Agency website',
  'Ime prijavnice': 'Application form name',
  'Povezava do prijavnice': 'Application form link',
  'Izpitni roki (povezava)': 'Exam dates (link)',
  'Navodila šole za prijavo (povezava)': 'School instructions for applying (link)',
  'Naslov za pošiljanje prijave': 'Address to send the application to',
  'Več vrstic.': 'Multiple lines.',
  'Teoretična vprašanja (povezava)': 'Theory questions (link)',
  'Hitra povezava na zaslonu tečajnika.': 'Quick link on the student screen.',
  'Učbenik (povezava)': 'Textbook (link)',
  'Spremembe veljajo za vse tečajnike šole.': 'Changes apply to all students of the school.',
  'Shrani nastavitve': 'Save settings',

  // šola — program
  'Besedilo ne vsebuje nobene vaje.': 'The text contains no exercises.',
  'Prebranih {n} vaj. Preglej in shrani.': '{n} exercises parsed. Review and save.',
  'Dodanih {n} vaj na konec. Preglej in shrani.': '{n} exercises added at the end. Review and save.',
  'Shranim program?': 'Save the syllabus?',
  'Velja za vseh {n} aktivnih tečajnikov. Že potrjene vaje ostanejo potrjene.':
    'Applies to all {n} active students. Already confirmed exercises stay confirmed.',
  'Program je shranjen.': 'Syllabus saved.',
  'Vaje in pod-vaje, ki jih tečajniki odkljukajo in ti potrdiš. Pod-vaj ne moreš izbrisati ali preurediti — nanje so vezane že potrjene vaje — lahko pa jih preimenuješ, dodaš nove na konec ali skriješ celo vajo.':
    'Exercises and sub-exercises that students tick and you confirm. Sub-exercises cannot be deleted or reordered — confirmed exercises are tied to them — but you can rename them, add new ones at the end or hide a whole exercise.',
  'Začni s Perutovim programom': 'Start from the Perut syllabus',
  'Uvozi program iz besedila': 'Import syllabus from text',
  'Prilepi program iz svojega dokumenta: vrstica je vaja, vrstica z vezajem je pod-vaja, vrstica z # je sklop.':
    'Paste the syllabus from your document: one line per exercise, a dash for a sub-exercise, # for a section.',
  'Ker šola še nima tečajnikov, besedilo zamenja celoten program.': 'Since the school has no students yet, the text replaces the whole syllabus.',
  'Šola ima {n} tečajnikov, zato se vaje iz besedila dodajo na konec; obstoječih ne spreminja.':
    'The school has {n} students, so exercises from the text are added at the end; existing ones are not changed.',
  'Program kot besedilo': 'Syllabus as text',
  '# Začetni tečaj\nVaja 1: Priprava\n- Razprostiranje krila\n- Pet kontrolnih točk\nVaja 2: Dvig krila\n- Polnjenje':
    '# Beginner course\nExercise 1: Preparation\n- Laying out the wing\n- Five-point check\nExercise 2: Wing inflation\n- Inflating',
  'Preberi besedilo': 'Parse text',
  'Ime sklopa': 'Section name',
  'Naslov vaje {id}': 'Title of exercise {id}',
  skrita: 'hidden',
  'Pod-vaja {n} vaje {id}': 'Sub-exercise {n} of exercise {id}',
  'Pod-vaja': 'Sub-exercise',
  'Nova vaja v ta sklop': 'New exercise in this section',
  'Nov sklop (npr. tandem, SIV)': 'New section (e.g. tandem, SIV)',
  'Shrani program': 'Save syllabus',

  // šola — inštruktorji
  'Vpiši veljaven e-poštni naslov.': 'Enter a valid email address.',
  'Inštruktor je dodan. Prijavi se z Googlom s tem naslovom.': 'Instructor added. They sign in with Google using this address.',
  'Odstranim inštruktorja?': 'Remove the instructor?',
  '{who} ne bo več videl tečajnikov te šole.': '{who} will no longer see this school’s students.',
  'Odstranjen.': 'Removed.',
  'Vsak inštruktor se prijavi s svojim Google računom. Dodaš ga po e-pošti; vidi in potrjuje tečajnike te šole, ne vidi pa opomb platforme in ne ureja licence.':
    'Each instructor signs in with their own Google account. Add them by email; they see and confirm this school’s students but do not see platform notes or manage the licence.',
  lastnik: 'owner',
  inštruktor: 'instructor',
  ' · še ni prijavljen': ' · not signed in yet',
  'Ni inštruktorjev': 'No instructors',
  'Dodaj inštruktorja': 'Add an instructor',
  'E-pošta (Google račun)': 'Email (Google account)',

  // šola — licenca
  'Kopirano.': 'Copied.',
  Preizkus: 'Trial',
  Aktivna: 'Active',
  Zamrznjena: 'Frozen',
  Zaprta: 'Closed',
  Paket: 'Plan',
  leto: 'year',
  'brez omejitve': 'no limit',
  'čez {n} dni': 'in {n} days',
  potekla: 'expired',
  aktivnih: 'active',
  'kvota polna': 'quota full',
  'Oznaka šole': 'School slug',
  'Za spremembo paketa ali podaljšanje piši na': 'To change your plan or renew, write to',
  'Cenik in paketi:': 'Pricing and plans:',
  'Vpis tečajnikov': 'Student sign-up',
  'Tečajnik se prijavi z Googlom in izbere tvojo šolo. Najlažje: pošlji mu to povezavo ali kodo šole. Oboje lahko objaviš na svoji spletni strani.':
    'Students sign in with Google and pick your school. Easiest: send them this link or the school code. You can publish both on your website.',
  'Kopiraj povezavo': 'Copy link',
  'Koda šole:': 'School code:',
};
